import React, {useEffect, useMemo} from "react";
import BudgetPaymentInput from "../BudgetPaymentInput.jsx";
import {FormInputV2} from "../../../../components/form/index.jsx";
import {PaymentType} from "../../../../consts.js";
import {TenBisPaymentInput} from "../TenBisPaymentInput/index.js";
import "./payment-input.css";
import {BankTransferPaymentInput} from "../BankTransferPaymentInput.jsx";
import {NOOP} from "../../../../utils/NOOP.jsx";
import {CreditCardPaymentInput} from "../CreditCardPaymentInput";

export const PaymentInput = ({
    onInvoiceCommentChange,
    invoiceComment,
    onInvoicePONumberChange,
    invoicePONumber,
    onSeparateInvoiceChange,
    paymentType,
    setPaymentType,
    budgetCategoriesPriority,
    separateInvoice,
    creditCard,
    setCreditCard,
    onBudgetCategoriesPriorityChange,
    allowedPaymentMethods,
    updateFormValues,
    creditCardToolTipInfo,
    tenBisCreditCard,
    budgetLoadRequestAmount,
    log = NOOP,
    me = {},
    company = {},
    shouldSaveCreditCard = true,
    onSyncUserBudget = NOOP,
    services = []
}) => {
    const paymentMethodsWithAllowedStatus = useMemo(
        () =>
            Object.values(allowedPaymentMethods ?? PaymentType).reduce(
                (allowed, paymentType) => ({
                    ...allowed,
                    [paymentType]: me.isCompanySubAdmin ? me.allowedPaymentsMethods?.includes(paymentType) : true
                }),
                {}
            ),
        [allowedPaymentMethods, me?.allowedPaymentsMethods, me?.isCompanySubAdmin]
    );

    useEffect(() => {
        const onlyAllowedPaymentMethods = Object.entries(paymentMethodsWithAllowedStatus).filter(([key, val]) => val);
        if (
            onlyAllowedPaymentMethods.length === 1 &&
            me.features?.company_master_budget_load &&
            onlyAllowedPaymentMethods[0][0] !== PaymentType.Budget
        ) {
            setPaymentType(onlyAllowedPaymentMethods[0][0]);
        }
    }, [paymentMethodsWithAllowedStatus, setPaymentType, me.features?.company_master_budget_load]);

    return (
        <>
            <div className="payment-input-containers">
                {[PaymentType.BankTransfer, PaymentType.Budget].includes(paymentType) ? (
                    <div className="payment-input-comments-type-container">
                        <div className="payment-input-invoice-comment-container">
                            <div className="payment-input-invoice-comment-input">
                                <FormInputV2
                                    placeholder={"הערות לציון על החשבונית"}
                                    onChange={e => onInvoiceCommentChange(e.target.value)}
                                    value={invoiceComment}
                                />
                            </div>
                            <div className="payment-input-tooltip-text-bank-transfer">{"עד 100 תווים"}</div>
                        </div>

                        <div>
                            <FormInputV2
                                placeholder={`מס׳ הזמנת רכש`}
                                value={invoicePONumber}
                                style={{width: "150px"}}
                                onChange={e => onInvoicePONumberChange(e.target.value)}
                            />
                        </div>
                    </div>
                ) : null}

                {paymentMethodsWithAllowedStatus[PaymentType.Card] ? (
                    <CreditCardPaymentInput
                        paymentType={paymentType}
                        setPaymentType={setPaymentType}
                        creditCard={creditCard}
                        me={me}
                        company={company}
                        setCreditCard={setCreditCard}
                        creditCardToolTipInfo={creditCardToolTipInfo}
                        shouldSaveCreditCard={shouldSaveCreditCard}
                    />
                ) : null}

                {paymentMethodsWithAllowedStatus[PaymentType.BankTransfer] ? (
                    <BankTransferPaymentInput
                        paymentType={paymentType}
                        setPaymentType={setPaymentType}
                        onSeparateInvoiceChange={onSeparateInvoiceChange}
                        separateInvoice={separateInvoice}
                        me={me}
                    />
                ) : null}

                {paymentMethodsWithAllowedStatus[PaymentType.Budget] ? (
                    <BudgetPaymentInput
                        paymentType={paymentType}
                        setPaymentType={setPaymentType}
                        budgetsPriority={budgetCategoriesPriority}
                        onBudgetCategoriesPriorityChange={onBudgetCategoriesPriorityChange}
                        budgetLoadRequestAmount={budgetLoadRequestAmount}
                        log={log}
                        me={me}
                        company={company}
                        onSyncUserBudget={onSyncUserBudget}
                        services={services}
                    />
                ) : null}

                {me?.features?.ten_bis_payment && paymentMethodsWithAllowedStatus[PaymentType.TenBisCard] ? (
                    <TenBisPaymentInput
                        setPaymentType={setPaymentType}
                        paymentType={paymentType}
                        updateFormValues={updateFormValues}
                        tenBisCreditCard={tenBisCreditCard}
                    />
                ) : null}
            </div>
        </>
    );
};
